export default {
  custom: {
    loginEmail: {
      required: 'The email field must be a valid Colonial Life email address.',
      regex: 'The email field must be a valid Colonial Life email address.'
    },
    producerName: {
      required: 'Producer Name is required.'
    },
    producerNumber: {
      required: 'Producer Number is required.',
      numeric: 'Please enter your Producer Number (numeric characters only).'
    },
    brokerName: {
      required: 'Broker Name is required.'
    },
    caseName: {
      required: 'Case Name is required.'
    },
    caseSize: {
      required: 'Case Size is required.',
      numeric: 'Please enter your case size (numeric characters only).'
    },
    caseState: {
      required: 'Case State is required.'
    },
    'unknown-platform__name': {
      required: 'Platform Name is required.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/appConfig/validationMessages.js